export const isMobile = (): boolean => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) 
};

export const isAndroid = (): boolean => {
  return /Android/i.test(navigator.userAgent);
};

export const isIos = (): boolean => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};